// extracted by mini-css-extract-plugin
module.exports = {"Banner":"NavCommon_Banner__mDq6B"};